import { organizationTypes } from "../actions/organization";

const initialState = {
  isLoading: false,
  isLoadingAlarmCount: false,
  currentModal: false,
  shouldUpdate: false,
  isDownloaded: "",
  data: [],
  filter: {
    isLoaded: false,
    org_name:"",
    name:"",
    lastupdated:"",
    updatedval:"",
    lastUpdatedto: "",
    lastUpdatedfrom: "",
    limit: 10,
    pageNo: 0,
  },
  alarmCounts: {},
  error: null,
};

const organizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case organizationTypes.FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case organizationTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoadingAlarmCount: true,
        data: action.payload,
        filters: {
          ...state.filters,
           ...action.payload,
          isLoaded: true,
        },
        error: null,
      };
    case organizationTypes.ALARM_COUNT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoadingAlarmCount: false,
        alarmCounts: action.payload
      };
    case organizationTypes.FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoadingAlarmCount: false,
        alarmCounts: {},
        error: action.payload,
      };
       case organizationTypes.UPDATE_PAGINATION_REQUEST:
            return {
              ...state,
              shouldUpdate: !state.shouldUpdate,
              filter: {
                ...state.filter,
                ...action.payload,
              },
            };
    case organizationTypes.DOWNLOAD_REQUEST:
      return {
        ...state,
        isDownloaded: "Downloading....",
      };
    case organizationTypes.DOWNLOAD_SUCCESS:
      return {
        ...state,
        isDownloaded: "Downloaded",
      };
    case organizationTypes.DOWNLOAD_FAILURE:
      return {
        ...state,
        isDownloaded: "Something Went Wrong",
        error: action.payload,
      };
    case organizationTypes.SET_CURRENT_MODAL:
      return {
        ...state,
        currentModal: action.payload,
      }
    default:
      return state;
  }
};

export default organizationReducer;
